jQuery(document).ready(function() {
    var slickOpts = {
      slidesToShow: 3.2,
      // rows: 2,
      slidesToScroll: 3,
      easing: 'swing',
      speed: 700,
      dots: true,
      infinite: false,
      arrows: true,
      customPaging: function(slick,index) {
        if (index < 10) {
          return '<a>0' + (index + 1) + '</a>';
        } else {
          return '<a>' + (index + 1) + '</a>';
        }
      },
      prevArrow: jQuery('.gallery-prev'),
      nextArrow: jQuery('.next-arrow'),
      appendDots: jQuery('#galleryDots'),
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2.2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
            dots: false,
            // rows: 1,
          }
        }
      ]
    };
    // Init slick carousel
    jQuery('#blogGallery').slick(slickOpts);
  });
  

// jQuery('.blog-listing .filter-container #caseStudiesFilterSelect').on('change', function() {
//   jQuery('#caseStudiesFilterButton').click();
// });

function runCaseStudySlider() {
  jQuery('#blogGallery').slick(slickOpts);
}

jQuery(document).ready(function() {
  var slideCount = jQuery('#blogGallery').slick("getSlick").slideCount;
  console.log('');
  if (jQuery(window).width() > 1000) {
    if (slideCount <= 3) {
      jQuery('.gallery-dots-container .gallery-next').hide();
    } 
  } else if (jQuery(window).width() > 600) {
    if (slideCount <= 2) {
      jQuery('.gallery-dots-container .gallery-next').hide();
    } 
  } else {
    if (slideCount <= 1 ) {
      jQuery('.gallery-dots-container .gallery-next').hide();
    }
  }
});